import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="terms">
      <Header />
      <div className="main-content  full-width  inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div
                      className="col-md-12 center-column  content-with-background "
                      id="content"
                    >
                      <div style={{ paddingBottom: 10 }}>
                        {/* Terms and Conditions Page */}
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            {/* Page Title */}
                            <h1 className="pdh-policy-title">
                              Pawluna – Website &amp; Sale of Goods
                              <br />
                              Terms and Conditions
                            </h1>
                            {/* Two Column Layout */}
                            <div className="pdh-policy-layout">
                              {/* Main Content */}
                              <div className="pdh-policy-main">
                                {/* Section List */}
                                <div className="pdh-policy-sections">
                                  {/* 1. About this website */}
                                  <div className="pdh-policy-section">
                                    <ol start={1}>
                                      <li className="pdh-policy-section-title">
                                        About this website
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        1.1 These terms and conditions (the
                                        "Terms") apply to your use of the
                                        Pawluna website and to any orders you
                                        place through it. By accessing this
                                        website and/or placing an order, you
                                        agree to be bound by these Terms.
                                      </p>
                                      <p className="pdh-policy-text">
                                        1.2 These Terms do not affect any
                                        statutory rights that you have and which
                                        cannot be limited by law.
                                      </p>
                                      <p className="pdh-policy-text">
                                        1.3 This site is owned and operated by
                                        Pawluna Limited ("Pawluna", "PDH", "we",
                                        "our", "us").
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          Registered in England and Wales under
                                          company number: 7400049
                                        </li>
                                        <li>VAT number: GB169438762</li>
                                      </ul>
                                      <p className="pdh-policy-text">
                                        1.4 The website may be used by:
                                        <br />
                                        a) consumers (pet owners buying for
                                        personal use); and
                                        <br />
                                        b) business customers (including
                                        retailers, distributors and
                                        OEM/private-label customers).
                                      </p>
                                      <p className="pdh-policy-text">
                                        Where a clause applies only to consumers
                                        or only to business customers, this is
                                        clearly indicated.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 2. Amendments */}
                                  <div className="pdh-policy-section">
                                    <ol start={2}>
                                      <li className="pdh-policy-section-title">
                                        Amendments
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        2.1. We aim to constantly improve and
                                        develop the PDH website for the benefit
                                        of all our customers.
                                      </p>
                                      <p className="pdh-policy-text">
                                        2.2. We reserve the right, at our sole
                                        discretion, to change, modify, add, or
                                        delete portions of this website (or any
                                        part of it) at any time with or without
                                        notice.
                                      </p>
                                      <p className="pdh-policy-text">
                                        2.3. We may change these Terms from time
                                        to time. Any changes will be effective
                                        when posted on the website. Your
                                        continued use of the website after any
                                        such changes constitutes your acceptance
                                        of the updated Terms.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 3. Use of the website and accounts */}
                                  <div className="pdh-policy-section">
                                    <ol start={3}>
                                      <li className="pdh-policy-section-title">
                                        Use of the website and accounts
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        3.1. You agree to use the website only
                                        for lawful purposes and in a way that
                                        does not infringe the rights of, or
                                        restrict or inhibit the use and
                                        enjoyment of the website by, any other
                                        person.
                                      </p>
                                      <p className="pdh-policy-text">
                                        3.2. To place orders you may be required
                                        to create an account. You must ensure
                                        that the information you provide is
                                        accurate and kept up to date, and that
                                        your login details are kept
                                        confidential. You are responsible for
                                        all activities carried out under your
                                        account.
                                      </p>
                                      <p className="pdh-policy-text">
                                        3.3. We may suspend or terminate access
                                        to your account or the website if we
                                        reasonably believe that you have
                                        breached these Terms or that your
                                        account is being misused.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 4. Product information and quality */}
                                  <div className="pdh-policy-section">
                                    <ol start={4}>
                                      <li className="pdh-policy-section-title">
                                        Product information and quality
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        4.1. We use our best efforts to provide
                                        you with high-quality products at
                                        reasonable and consistent prices.
                                      </p>
                                      <p className="pdh-policy-text">
                                        4.2. We always try to represent product
                                        images, descriptions and specifications
                                        as accurately as possible. However, we
                                        cannot guarantee that colours and
                                        details displayed on your screen will be
                                        a perfectly accurate representation of
                                        the actual product, and reasonable
                                        variations may occur.
                                      </p>
                                      <p className="pdh-policy-text">
                                        4.3. All products are subject to
                                        availability. We may change or
                                        discontinue products without notice,
                                        provided that such changes do not affect
                                        orders we have already accepted.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 5. Prices, currency and VAT */}
                                  <div className="pdh-policy-section">
                                    <ol start={5}>
                                      <li className="pdh-policy-section-title">
                                        Prices, currency and VAT
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        5.1. All prices on the website are in UK
                                        Pounds Sterling (GBP).
                                      </p>
                                      <p className="pdh-policy-text">
                                        5.2. For consumer customers, prices
                                        displayed on the product pages are
                                        normally inclusive of VAT. Any delivery
                                        charges or additional fees will be shown
                                        clearly before you place your order.
                                      </p>
                                      <p className="pdh-policy-text">
                                        5.3. For business customers, prices may
                                        be shown exclusive of VAT, which will be
                                        added at the appropriate rate at
                                        checkout or on invoice, together with
                                        any applicable delivery or other
                                        charges.
                                      </p>
                                      <p className="pdh-policy-text">
                                        5.4. If you pay using another currency,
                                        the exchange rate and any currency
                                        conversion charges will be determined by
                                        the relevant payment processing system
                                        or your card issuer, and not by us.
                                      </p>
                                      <p className="pdh-policy-text">
                                        5.5. We may change our prices at any
                                        time. The price applicable to your order
                                        will be the price shown on the website
                                        when you submit your order, except in
                                        the case of obvious error.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 6. Ordering, acceptance and contract formation */}
                                  <div className="pdh-policy-section">
                                    <ol start={6}>
                                      <li className="pdh-policy-section-title">
                                        Ordering, acceptance and contract
                                        formation
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        6.1. By placing an order through the
                                        website, you are making an offer to
                                        purchase products in accordance with
                                        these Terms.
                                      </p>
                                      <p className="pdh-policy-text">
                                        6.2. PDH reserves the right to reject
                                        any purchase order without giving a
                                        reason and no order is accepted without
                                        being checked and approved.
                                      </p>
                                      <p className="pdh-policy-text">
                                        6.3. After you place an order, you may
                                        receive an acknowledgement email. This
                                        confirms that we have received your
                                        order but does not mean that it has been
                                        accepted.
                                      </p>
                                      <p className="pdh-policy-text">
                                        6.4. A binding contract between you and
                                        PDH is formed only when we send you an
                                        order confirmation or dispatch
                                        confirmation email, or when we dispatch
                                        the goods, whichever occurs first.
                                      </p>
                                      <p className="pdh-policy-text">
                                        6.5. If we are unable to fulfil your
                                        order or we decide to reject it, we will
                                        email you to confirm this and will
                                        refund any monies paid for rejected
                                        orders or items we cannot fulfil.
                                      </p>
                                      <p className="pdh-policy-text">
                                        6.6. For OEM or bespoke orders placed
                                        via quotation or offline, a contract is
                                        formed when you accept our written
                                        quotation or purchase order
                                        confirmation, subject to any separate
                                        OEM agreement. Where there is a
                                        conflict, the signed OEM agreement will
                                        prevail over these Terms.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 7. Payment */}
                                  <div className="pdh-policy-section">
                                    <ol start={7}>
                                      <li className="pdh-policy-section-title">
                                        Payment
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        7.1. Unless different credit terms have
                                        been agreed in writing, payment is taken
                                        at the time of order to avoid delays in
                                        dispatch.
                                      </p>
                                      <p className="pdh-policy-text">
                                        7.2. You are responsible for ensuring
                                        that all billing, delivery and payment
                                        details you provide are correct and that
                                        you are authorised to use the chosen
                                        payment method.
                                      </p>
                                      <p className="pdh-policy-text">
                                        7.3. Payment is taken via a third-party
                                        payment processor to which you are
                                        directed upon completing your order. The
                                        terms of payment for that transaction
                                        are determined by the payment processor,
                                        and you should review their terms before
                                        making payment.
                                      </p>
                                      <p className="pdh-policy-text">
                                        7.4. If the issuer of your payment card
                                        or chosen payment method refuses to
                                        authorise payment to us, we will not be
                                        liable for any delay or non-delivery.
                                      </p>
                                      <p className="pdh-policy-text">
                                        7.5. For business customers with agreed
                                        credit terms, payment must be made in
                                        accordance with those terms. We reserve
                                        the right to suspend or cancel further
                                        deliveries if payments are overdue and
                                        to charge interest on overdue sums as
                                        permitted by law.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 8. Delivery, risk and title */}
                                  <div className="pdh-policy-section">
                                    <ol start={8}>
                                      <li className="pdh-policy-section-title">
                                        Delivery, risk and title
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        8.1. Delivery options, charges and
                                        estimated delivery times will be shown
                                        at checkout or set out in our quotation.
                                      </p>
                                      <p className="pdh-policy-text">
                                        8.2. Any delivery date or time we
                                        provide is an estimate only, although we
                                        will use reasonable efforts to deliver
                                        within the stated timeframe.
                                      </p>
                                      <p className="pdh-policy-text">
                                        8.3. Risk of loss or damage to the
                                        products passes to you when the products
                                        are delivered to the delivery address
                                        you specify (or, if you arrange your own
                                        carrier, when we hand the goods to your
                                        carrier).
                                      </p>
                                      <p className="pdh-policy-text">
                                        8.4. For business customers, title to
                                        the products does not pass to you until
                                        we have received payment in full in
                                        cleared funds for those products and all
                                        other sums then due to us. Until title
                                        passes, you must store the products
                                        separately, keep them insured and
                                        clearly identifiable as our property.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 9. Cancellation and returns – consumers (distance/online sales) */}
                                  <div className="pdh-policy-section">
                                    <ol start={9}>
                                      <li className="pdh-policy-section-title">
                                        Cancellation and returns – consumers
                                        (distance/online sales)
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        This section applies only if you are a
                                        consumer and have purchased online or by
                                        other distance means.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.1. Legal right to cancel (cooling-off
                                        period)
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.1.1. If you are a consumer, you have a
                                        legal right to cancel most online orders
                                        within 14 days without giving any
                                        reason, in accordance with the Consumer
                                        Contracts (Information, Cancellation and
                                        Additional Charges) Regulations 2013.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.1.2. The cancellation period expires
                                        14 days after the day on which you (or
                                        someone you nominate) receive the
                                        products (or, for orders delivered in
                                        instalments, after the last item is
                                        delivered).
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.2. How to cancel
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.2.1. To exercise the right to cancel,
                                        you must inform us of your decision to
                                        cancel your order by a clear statement
                                        (for example, by email or letter) using
                                        the contact details on our website and
                                        including your order number and details
                                        of the items you wish to cancel.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.2.2. You may, but are not required to,
                                        use any model cancellation form we
                                        provide on our website.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.3. Returning goods after cancellation
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.3.1. Once you have notified us that
                                        you wish to cancel, you must send back
                                        the products to us without undue delay
                                        and in any event no later than 14 days
                                        from the day on which you inform us of
                                        your decision to cancel.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.3.2. Unless the products are faulty or
                                        mis-described, you are responsible for
                                        the direct cost of returning the
                                        products and for ensuring that they are
                                        adequately packaged.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.4. Refunds after cancellation
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.4.1. We will refund all payments
                                        received from you for the cancelled
                                        products, including the cost of the
                                        least expensive standard delivery option
                                        we offer (if you paid for delivery), in
                                        accordance with CCR 2013.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.4.2. We will make the refund without
                                        undue delay and not later than:
                                        <br />
                                        a) 14 days after the day we receive the
                                        returned products; or
                                        <br />
                                        b) if earlier, 14 days after the day you
                                        provide evidence that you have sent the
                                        products back.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.4.3. We will make the refund using the
                                        same means of payment you used for the
                                        initial transaction, unless we have
                                        expressly agreed otherwise.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.4.4. We may make a deduction from the
                                        refund for any loss in value of the
                                        products where this results from
                                        unnecessary handling by you beyond what
                                        is necessary to establish the nature,
                                        characteristics and functioning of the
                                        products.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.5. Exceptions to the right to cancel
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.5.1. The right to cancel does not
                                        apply to, for example:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          goods made to your specification or
                                          clearly personalised (including OEM /
                                          private-label products);
                                        </li>
                                        <li>
                                          goods which are not suitable for
                                          return for health or hygiene reasons
                                          if they have been unsealed after
                                          delivery;
                                        </li>
                                        <li>
                                          any other items that are excluded from
                                          cancellation rights by law.
                                        </li>
                                      </ul>
                                      <p className="pdh-policy-text">
                                        9.5.2. Your statutory rights in relation
                                        to faulty or mis-described products are
                                        unaffected by this section.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 10. Returns – business / trade & OEM customers */}
                                  <div className="pdh-policy-section">
                                    <ol start={10}>
                                      <li className="pdh-policy-section-title">
                                        Returns – business / trade &amp; OEM
                                        customers
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        This section applies only if you are a
                                        business customer (including trade and
                                        OEM/private-label customers).
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.1. The returns policy of Pawluna for
                                        business customers is to accept product
                                        returns (or offer compensation for
                                        products you wish to return, if
                                        acceptable) only for goods that were
                                        wrongly delivered and/or are faulty.
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.2. For any other return reason
                                        (including, for example, overstock,
                                        change of mind or slow sales), you must
                                        contact Pawluna directly or via the
                                        Returns Form so that the return case can
                                        be reviewed. The outcome will be
                                        reported to you, usually via email. We
                                        are under no obligation to accept such
                                        returns.
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.3. You must inspect the products
                                        promptly on delivery and notify us in
                                        writing within a reasonable period (and
                                        in any event within [e.g. 7 days]) of
                                        any shortages, incorrect deliveries or
                                        apparent defects.
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.4. Where products are confirmed by us
                                        as wrongly delivered or faulty, we will,
                                        at our option:
                                        <br />
                                        a) repair the products;
                                        <br />
                                        b) replace the products; or
                                        <br />
                                        c) issue a credit note or refund for the
                                        affected products.
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.5. We may request photographic
                                        evidence and/or the return of goods for
                                        inspection before agreeing any remedy.
                                      </p>
                                      <p className="pdh-policy-text">
                                        10.6. Nothing in this section is
                                        intended to limit any non-excludable
                                        statutory rights you may have as a
                                        business customer.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 11. Faulty products and your legal rights */}
                                  <div className="pdh-policy-section">
                                    <ol start={11}>
                                      <li className="pdh-policy-section-title">
                                        Faulty products and your legal rights
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        11.1. All products supplied must be of
                                        satisfactory quality, fit for purpose
                                        and as described, as required by the
                                        Consumer Rights Act 2015.
                                      </p>
                                      <p className="pdh-policy-text">
                                        11.2. If you are a consumer and the
                                        goods are faulty, unfit for purpose or
                                        not as described:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          you have a short-term right to reject
                                          the goods and obtain a refund within
                                          30 days of delivery;
                                        </li>
                                        <li>
                                          after 30 days, you may be entitled to
                                          a repair or replacement and, if that
                                          is not successful, a price reduction
                                          or final right to reject, in
                                          accordance with CRA 2015.
                                        </li>
                                      </ul>
                                      <p className="pdh-policy-text">
                                        11.3. If you are a business customer,
                                        our responsibility for defective
                                        products is limited as set out in
                                        sections 10 and 12 of these Terms and/or
                                        in any separate trade or OEM agreement
                                        between us.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 12. Our liability */}
                                  <div className="pdh-policy-section">
                                    <ol start={12}>
                                      <li className="pdh-policy-section-title">
                                        Our liability
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        12.1. Nothing in these Terms excludes or
                                        limits our liability for:
                                        <br />
                                        a) death or personal injury caused by
                                        our negligence;
                                        <br />
                                        b) fraud or fraudulent
                                        misrepresentation; or
                                        <br />
                                        c) any other matter for which it would
                                        be unlawful to exclude or limit
                                        liability.
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.2. Consumers
                                      </p>
                                      <p className="pdh-policy-text">
                                        If you are a consumer:
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.2.1. We are responsible for loss or
                                        damage you suffer that is a foreseeable
                                        result of our breaking these Terms or
                                        our failing to use reasonable care and
                                        skill.
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.2.2. We are not responsible for loss
                                        or damage that is not foreseeable, or
                                        for losses relating to any business of
                                        yours (including any loss of profit,
                                        loss of business, or loss of business
                                        opportunity).
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.3. Business customers
                                      </p>
                                      <p className="pdh-policy-text">
                                        If you are a business customer:
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.3.1. To the fullest extent permitted
                                        by law, all warranties, conditions and
                                        other terms implied by statute or common
                                        law are excluded.
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.3.2. Subject to clause 12.1, our
                                        total aggregate liability to you for all
                                        loss or damage arising out of or in
                                        connection with any contract between us
                                        shall not exceed the total amount paid
                                        by you for the products giving rise to
                                        the claim.
                                      </p>
                                      <p className="pdh-policy-text">
                                        12.3.3. We shall not be liable for any:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          loss of profit, revenue or business;
                                        </li>
                                        <li>loss of anticipated savings;</li>
                                        <li>loss of goodwill; or</li>
                                        <li>
                                          indirect or consequential loss or
                                          damage, in each case whether arising
                                          in contract, tort (including
                                          negligence) or otherwise, even if
                                          foreseeable.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/* 13. Force majeure */}
                                  <div className="pdh-policy-section">
                                    <ol start={13}>
                                      <li className="pdh-policy-section-title">
                                        Force majeure
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        We shall not be liable for any failure
                                        or delay in performing any of our
                                        obligations where that failure or delay
                                        results from events or circumstances
                                        beyond our reasonable control, including
                                        (without limitation) strikes, industrial
                                        disputes, failure of utilities or
                                        transport networks, acts of God, war,
                                        terrorism, epidemics, pandemics, natural
                                        disasters, extreme weather, or the
                                        default of suppliers or subcontractors.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 14. General */}
                                  <div className="pdh-policy-section">
                                    <ol start={14}>
                                      <li className="pdh-policy-section-title">
                                        General
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        14.1. If any provision of these Terms is
                                        found by any court or competent
                                        authority to be invalid, unlawful or
                                        unenforceable, that provision shall be
                                        deemed deleted and the remaining
                                        provisions shall continue in full force
                                        and effect.
                                      </p>
                                      <p className="pdh-policy-text">
                                        14.2. You may not assign or transfer
                                        your rights or obligations under these
                                        Terms without our prior written consent.
                                        We may transfer our rights and
                                        obligations under these Terms to another
                                        organisation.
                                      </p>
                                      <p className="pdh-policy-text">
                                        14.3. No failure or delay by us in
                                        exercising any right or remedy under
                                        these Terms shall operate as a waiver of
                                        that right or remedy.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 15. Governing law and jurisdiction */}
                                  <div className="pdh-policy-section">
                                    <ol start={15}>
                                      <li className="pdh-policy-section-title">
                                        Governing law and jurisdiction
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        These Terms and any dispute or claim
                                        arising out of or in connection with
                                        them, or with any contract between us,
                                        shall be governed by and construed in
                                        accordance with the laws of England and
                                        Wales.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                {/* Footer Divider and Last Updated */}
                                <div className="pdh-policy-footer">
                                  <div className="pdh-policy-footer-divider" />
                                  <p className="pdh-policy-last-updated">
                                    Last updated: 09/12/2025
                                  </p>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Terms;
